/*
 * @Description: 国际化-繁体中文（台湾），此处导入并统一导出所有页面或组件的国际化文件配置，多层json结构防止冲突并使结构更清晰
 * @Author: AI
 * @Date: 2026-03-16 00:00:00
 * @LastEditTime: 2026-03-16 00:00:00
 * @LastEditors: AI
 */

import commonI18n from './common/zh-TW.json';
import downloadI18n from '@/pages/download/local/zh-TW.json';

const zhTW = {
    common: commonI18n,
    pages: { download: downloadI18n },
    components: {},
};

export default zhTW;
